import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=728fbd39&scoped=true"
import script from "./contact.vue?vue&type=script&setup=true&lang=js"
export * from "./contact.vue?vue&type=script&setup=true&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=728fbd39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728fbd39",
  null
  
)

export default component.exports